export const unitSettingsMixin = {
  methods: {
    programUnits(programSettings) {
      return this._.get(programSettings, "units", "Miles");
    },

    milesToProgramUnits(programSettings, miles) {
      const units = this._.get(programSettings, "units", "Miles");
      const multiplier = units === "Miles" ? 1 : 1.609344;
      return Math.round(multiplier * miles);
    },

    memberUnits(member) {
      return this._.get(member, "memberData.units", "");
    }
  }
};
